import React, { Component } from 'react';
import './CollectionsSlider.css';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { withRouter, NavLink } from 'react-router-dom';
import { routeCodes } from '../../../../config/routes';

class CollectionsSlider extends Component {

  constructor() {
    super();
    this.state = {
      activeSlider: false,
    };
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }

  toggleSlider() {
    const { activeSlider } = this.state;
    this.setState({
      activeSlider: !activeSlider,
    })
  }

  render() {
    const { data, language } = this.props;
    const { activeSlider } = this.state;

    const sliderClasses = classNames(
      'CollectionsSlider',
      activeSlider && 'CollectionsSlider--active',
    );

    return (
      <div className={sliderClasses} >
        <div className='ToggleSlider-Wrapper' onClick={() => this.toggleSlider()}>
          <button className='ToggleSlider' >
            <p>Collections List</p>
            <svg className='ArrowDown' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z"/></svg>
          </button>
        </div>
        <button onClick={() => this.toggleSlider()} className='SliderWrapper'>
          {data.map((collection, index) => {
            const collectionClasses = classNames(
              'CollectionNumber',
              `CollectionNumber--${index + 1}`
            );
            return (
              <NavLink className={collectionClasses} key={index} onClick={() => this.scrollToTop()} to={{ pathname: routeCodes.COLLECTION, state: { 'page': index } }}>
                <div className='CollectionsSlider-collection'>
                  <h2 className='CollectionsSlider-collection-title'>{collection.title[language]}</h2>
                </div>
              </NavLink>
            )
          })}
        </button>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language,
  }
}

export default withRouter(
  connect(mapStateToProps)(CollectionsSlider)
);


// WEBPACK FOOTER //
// ./src/components/Collections/CollectionsList/CollectionsSlider/index.js